import React from 'react';
import Navbar from './Navbar'
import Footer from './Footer'
import { DisplayAd_970_90, DisplayAd_728_90, DisplayAd_300_50 } from '../components/DisplayAd'
// import '../dev.css'

const Layout = ({ children }) => {
  const hn = window.location.hostname
  const s = hn === 'funfunvietnam.com' || process.env.NODE_ENV === 'development'
  
  return (
    <React.Fragment>  
      <header className="header">
      <Navbar />
      </header>
      <main className="main">{s ? children : ''}</main>
      <div className="ads">
        <DisplayAd_300_50 />
        <DisplayAd_728_90 />
        <DisplayAd_970_90 />
      </div>
      <Footer />
    </React.Fragment>
  )
}

export default Layout